import axios from 'axios';
const SERVER_URL_GOOGLE = "https://www.googleapis.com/geolocation/v1/"

const apiGoogle = axios.create({ baseURL: SERVER_URL_GOOGLE });

export default apiGoogle;
